import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'rm-preco',
  templateUrl: './t_preconization.component.html',
  styleUrls: ['./preconization.component.less']
})
export class PreconizationComponent implements OnInit {

  preco:any;

  constructor(public dialogRef: MatDialogRef<PreconizationComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  		this.preco = data.preco;
    }

  ngOnInit() {}

}
